<template>
    <div class="">
        <div class="card font-satoshi_r">
            <div class="card-content">
                <div class="flex justify-between items-center mb-5">
                    <div class="flex justify-center items-center spinner-bg rounded-full w-12 h-12">
                        <img src="@/assets/images/trendupp/Warning.svg" alt="">
                    </div>

                    <button 
                        @click="$emit('close')"
                        class="flex justify-center items-center bg-black rounded-full w-12 h-12"
                    >
                        <img src="@/assets/images/trendupp/X.svg" alt="">
                    </button>
                </div>

                <div class="mb-6">
                    <h3 class="text-base text-white mb-2">
                        Double-check before you vote!
                    </h3>

                    <p class="text-sm text-gray-x10">
                        Is this your final pick? <br />
                        You won’t be able to change it later.
                    </p>
                </div>

                <div class="buttons is-centered">
                    <button 
                        @click="confirmVoting()"
                        class="button is-primary is-fullwidth font-satoshi_r"
                        :class="isLoading ? 'is-loading' : ''"
                    >
                        <span class="text-sm">Yes, I'm Sure</span>
                    </button>

                    <button 
                        @click="$emit('close')" 
                        class="button is-ghost font-satoshi_r btn-ghost"
                    >
                        Let Me Check Again
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { postHandler } from "@/api/requestHandler";

    export default {
        components: {
        },

        data() {
            return {
                isLoading: false,
            }
        },

        props: {
            nomineData: {
                type: Object,
            }
        },

        methods: {
            async confirmVoting() {
                this.isLoading = true;

                    if (
                        !this.$route.query?.id || 
                        this.$route.query?.id == '' || 
                        this.$route.query?.id == 'undefined'
                    ) {
                        const payload =  {
                            errorName: 'undefined', 
                        };
                        this.$emit('callback', payload);
                        this.$emit('close');
                        
                    } else {
                        let response = await postHandler(`/customer/polls/trendupp/vote?id=${this.$route.query?.id}`, {
                            candidate_id: this.nomineData.id,
                        })

                        if (response.status === 201 && response.data.success) {
                            this.$router.push({ 
                                path: '/trendupp/redirect', 
                                query: { 
                                    id: this.$route.query?.id,
                                    status: true,
                                } 
                            })
                            this.$emit('close')

                        } else {
                            const payload =  {
                                errorName: 'custom',
                                data: response.data?.data,
                            }
                            this.$emit('callback', payload);
                            this.$emit('close');
                        }
                    }

                this.isLoading = false;
            },
        },

        mounted() {
        },
    };
</script>

<style scoped>
    .card {
        background-color: #fff !important;
        border-radius: 0.75rem !important;
        background-color: #000000 !important;
    }

    .spinner-bg {
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%), #0C0C0C;
	}

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }

    .button {
        border-radius: 12px !important;
    }

    .btn-ghost {
        color: #EFFCF3 !important;
        font-size: 14px !important;
        line-height: 24px !important;
    }
</style>
